// Darkens/lightens a hex color by `percent` (-100 to 100), used for hover states
export const shadeColor = (hex, percent) =>{
  if (!hex) return hex;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const num = parseInt(h, 16);
  let r = (num >> 16) + Math.round(2.55 * percent);
  let g = ((num >> 8) & 0x00ff) + Math.round(2.55 * percent);
  let b = (num & 0x0000ff) + Math.round(2.55 * percent);
  r = Math.min(255, Math.max(0, r));
  g = Math.min(255, Math.max(0, g));
  b = Math.min(255, Math.max(0, b));
  const combined = (1 << 24) | (r << 16) | (g << 8) | b;
  return `#${combined.toString(16).slice(1)}`;
}